import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// Pertahankan atribut sitasi (`data-doc-id`/`data-page` untuk klik + `data-doc-
// label`/`data-doc-judul`/`data-doc-nomor` untuk judul di daftar Referensi) agar
// TIDAK dibuang Quill saat konten AI dibuka/diedit/disimpan. Kalau atribut judul
// terbuang, sitasi kehilangan label → daftar referensi jatuh ke "Dokumen" (lihat
// `CitedContent`). Quill (Parchment) membuang atribut yang tidak terdaftar;
// daftarkan SEMUANYA sbg Attributor inline. Idempotent (modul di-load sekali).
/* eslint-disable @typescript-eslint/no-explicit-any */
try {
  const Parchment: any = Quill.import("parchment");
  const inline = { scope: Parchment.Scope.INLINE };
  for (const [name, attr] of [
    ["dataDocId", "data-doc-id"],
    ["dataPage", "data-page"],
    ["dataDocLabel", "data-doc-label"],
    ["dataDocJudul", "data-doc-judul"],
    ["dataDocNomor", "data-doc-nomor"],
  ] as const) {
    const Attr = new Parchment.Attributor.Attribute(name, attr, inline);
    Quill.register(Attr, true);
  }
} catch {
  // registrasi gagal (mis. SSR) — abaikan; editor tetap berfungsi.
}

// Dukungan TABEL: Quill 1.x tidak punya blot tabel, jadi tabel dari konten AI akan
// dibuang saat dibuka di editor. Kita daftarkan <table> sebagai BLOCK EMBED utuh —
// Quill menyimpan & menampilkannya apa adanya (tidak rontok saat edit/simpan).
// Konsekuensi: tabel = blok atomik (sel tidak diedit di dalam Quill); untuk mengubah
// isinya, generate ulang atau hapus bloknya. Garis/tampilan diatur di index.css.
try {
  const BlockEmbed: any = Quill.import("blots/block/embed");
  class TableBlot extends BlockEmbed {
    static create(value: string) {
      const node: HTMLElement = super.create();
      node.innerHTML = value; // value = innerHTML dari <table>
      return node;
    }
    static value(node: HTMLElement) {
      return node.innerHTML;
    }
  }
  TableBlot.blotName = "table";
  TableBlot.tagName = "table";
  Quill.register(TableBlot, true);
} catch {
  // abaikan bila gagal — editor tetap berfungsi.
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link", "image"],
  ["clean"],
];

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  className?: string;
}

export function RichTextEditor({ value, onChange, placeholder, readOnly, className }: Props) {
  return (
    <div className={className}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        modules={{ toolbar: readOnly ? false : TOOLBAR }}
      />
    </div>
  );
}
